import { HttpClient } from '@angular/common/http';
import {
    Component,
    Input,
    OnInit,
    OnDestroy,
    ChangeDetectorRef,
    ViewChild,
    Output,
    EventEmitter,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    BehaviorSubject,
    firstValueFrom,
    ObservableInput,
    takeUntil,
} from 'rxjs';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'drop-down-entity',
    templateUrl: './drop-down-entity.component.html',
    styleUrls: ['./drop-down-entity.component.scss'],
})
export class DropDownEntityComponent implements OnInit, OnDestroy {
    @Input() form: FormGroup;
    @Input() controlName: string;
    @Input() label: string;
    @Input() valueSelector: string;
    @Input() localized: boolean = false;

    @Input() getUrl: string;
    @Input() multiple: boolean = false;
    @Input() disabled: boolean = false;
    @Input() class: string = 'flex-auto  ml-2 mr-2';

    _unsubscribeAll: BehaviorSubject<boolean> = new BehaviorSubject(false);
    @Input() records: any[] = [];

    @Output('selectionChange') selectionChange = new EventEmitter()

    constructor(
        private _httpClient: HttpClient,
        private _changeDetectorRef: ChangeDetectorRef
    ) {}

    compareObjects(o1: any, o2: any) {
        return o1._id === o2._id;
    }
    async ngOnInit(): Promise<void> {
        this.form.statusChanges.subscribe((value) => {
            this._changeDetectorRef.markForCheck();
        });

        // console.log('====================================');
        // console.log(this.localized);
        // console.log('====================================');
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(true);
    }
}
